import { arenaEl, focusOverlayEl } from './dom.js';

// Turn keys are bound on the document, so a window that has lost keyboard focus
// steers nothing -- and the blur handler releases whatever key was held, which
// looks exactly like the game freezing. This band says what happened. It is a
// hint rather than a modal: clicking anywhere in the page restores focus by
// itself, the band just happens to be the thing under the pointer.
//
// A visible-but-unfocused window is the case worth serving here: someone
// watching the arena on a second monitor gets told why their keys do nothing,
// which is also why this does not care whether the tab is hidden.
function shouldShowFocusOverlay() {
  if (!focusOverlayEl) return false;
  if (typeof document.hasFocus === 'function' && document.hasFocus()) return false;
  // The lobby and the sign-in overlay own the whole viewport when they are up,
  // and take their own input; the arena band would just be a covered click
  // target. syncStageVisibility() calls back in when that changes.
  return Boolean(arenaEl && !arenaEl.classList.contains('is-offstage'));
}

function syncFocusOverlay() {
  if (!focusOverlayEl) return;
  focusOverlayEl.classList.toggle('is-visible', shouldShowFocusOverlay());
}

function initFocusOverlay() {
  if (!focusOverlayEl) return;
  focusOverlayEl.addEventListener('pointerdown', () => {
    // Clicking already hands focus back in a plain tab; the explicit call is
    // what covers the embedded case, where the parent page holds it instead.
    try { window.focus(); } catch (_) { }
    syncFocusOverlay();
  });
  window.addEventListener('focus', syncFocusOverlay);
  window.addEventListener('blur', syncFocusOverlay);
  document.addEventListener('visibilitychange', syncFocusOverlay);
  syncFocusOverlay();
}

export {
  initFocusOverlay,
  syncFocusOverlay
};
